import React from 'react';
import { View, Text } from 'react-native';
import { connect } from 'react-redux';
import { addContentToUserProgress } from "../../../../redux/actions";

import get from "../../../../api/methods/get";
import { CONTENT_GET_SPECIFIC } from "../../api/journeyEndpoints";

import Colors from "../../../../constants/Colors";
import {RenderBlocks, SpinnerControl} from '../../../../components';
import queryString from "query-string";
import NavBar from "../../../../components/NavBar";
import {KnowledgeElementTitle} from "../KnowledgeElementTitle";

class Article extends React.Component {

    state = {
        isFetching: false,
        contentData: null,
        blocks: [],
    }

    fetchOriginal = async () => {
	    if (this.state.isFetching) return;
	    this.setState({ isFetching: true });

	    try {
			const values = queryString.parse(this.props.location.search);
			const contentId = values.contentId;
	        let result = await get(CONTENT_GET_SPECIFIC("article", contentId));
	        let json = await result.json()

			await this.props.addContentToUserProgress('article', contentId);

	        this.setState({
	        	contentData: json.data,
	        	blocks: json.data.longDescription.blocks,
	        });


	    } catch (e) {
	    	console.log(e)
	    }

	    this.setState({ isFetching: false });
	}

	componentDidMount() {
    	this.fetchOriginal();
	}

	render() {

        return (
            <NavBar title={"Artigo"}>

                <SpinnerControl isFetching={this.state.isFetching} textPropsStyle={{ color: Colors.spinnerNoBackgroundTextColor }} />

				{
					this.state.contentData !== null &&
						<View>
							<KnowledgeElementTitle title={this.state.contentData.title} />

							<RenderBlocks
								blocks={this.state.blocks}
								style={{ margin: 20 }}
								textStyle={{ color: Colors.fontColorOnBackground, fontSize: 20 }}
							/>
						</View>
				}

            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return { }
}

export default connect(mapStateToProps, { addContentToUserProgress })(Article);
